import React from 'react';
import PropTypes from 'prop-types';
import CommentPresentation from './CommentPresentation';

export default function CommentContainer({ name, profileImageWebp, profileImageJpg, jobTitle, commentText }) {
  return (
    <CommentPresentation
      name={name}
      profileImageWebp={profileImageWebp}
      profileImageJpg={profileImageJpg}
      jobTitle={jobTitle}
      commentText={commentText}
    />
  );
}

CommentContainer.propTypes = {
  name: PropTypes.string.isRequired,
  profileImageWebp: PropTypes.object.isRequired,
  profileImageJpg: PropTypes.object.isRequired,
  jobTitle: PropTypes.string.isRequired,
  commentText: PropTypes.string.isRequired,
};
